<template>
     <base-section id="pricing" space="20">
          <v-container>
               <v-row justify="space-between">
                    <v-col cols="12" md="12" class="text-center">
                         <base-section-heading title="Services"
                              >Select Session Length</base-section-heading
                         >
                         <v-btn-toggle
                              v-model="toggle_exclusive"
                              background-color="accent"
                              active-class="primary white--text"
                         >
                              <v-btn tile>30 Minutes</v-btn>
                              <v-btn tile>45 Minutes</v-btn>
                              <v-btn tile>60 Minutes</v-btn>
                              <v-btn tile>90 Minutes</v-btn>
                         </v-btn-toggle>
                    </v-col>
               </v-row>
               <div class="pt-8"></div>
               <v-row justify="space-between">
                    <v-col
                         v-for="(card, index) in cards"
                         :key="index"
                         cols="12"
                         sm="4"
                         md="4"
                    >
                         <base-pricing-card
                              :name="card.name"
                              :description="card.description"
                              :price="card.price"
                              :featured="card.featured"
                         ></base-pricing-card>
                    </v-col>
               </v-row>
          </v-container>
     </base-section>
</template>

<script>
export default {
     name: 'SectionPricing',
     mounted() {
          this.toggle_exclusive = 2
          this.cards = this.sixty_cards
     },
     watch: {
          toggle_exclusive: function (val) {
               console.log(val)
               if (val == 0) this.cards = this.thirty_cards
               else if (val == 1) this.cards = this.fourty_cards
               else if (val == 2) this.cards = this.sixty_cards
               else if (val == 3) this.cards = this.ninety_cards
               else this.cards = this.sixty_cards
          },
     },
     data() {
          return {
               text: 'center',
               toggle_exclusive: 2,
               cards: [],
               thirty_cards: [
                    {
                         name: 'Product 1',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$45',
                    },
                    {
                         name: 'Product 2',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$55',
                         featured: true,
                    },
                    {
                         name: 'Product 3',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$60',
                    },
               ],
               fourty_cards: [
                    {
                         name: 'Product 1',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$65',
                    },
                    {
                         name: 'Product 2',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$75',
                         featured: true,
                    },
                    {
                         name: 'Product 3',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$85',
                    },
               ],
               sixty_cards: [
                    {
                         name: 'Product 1',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$80',
                    },
                    {
                         name: 'Product 2',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$90',
                         featured: true,
                    },
                    {
                         name: 'Product 3',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$95',
                    },
               ],
               ninety_cards: [
                    {
                         name: 'Product 1',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$110',
                    },
                    {
                         name: 'Product 2',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$120',
                         featured: true,
                    },
                    {
                         name: 'Product 3',
                         description:
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                         price: '$135',
                    },
               ],
          }
     },
}
</script>
